import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont } from '../../theme';

export const usePinFieldStyles = createStyles(() => ({
  showToggle: {
    width: 50,
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    color: ThemeColors.COLOR_RED,
  },
}));
